import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          热搜榜单
        </h2>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100 transition-colors duration-150 cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.hot}</div>
                <div className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-600' : 'text-accent-600'
                }`}>
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs`}></i>
                  {' '}{item.change}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}